import { useApi } from "../composables/useApi";

export const useAnyApi = useApi((args) => ({
  ...(args || {}),
}));
